import React from "react";
import { GoMarkGithub } from "react-icons/go";
// import DarkModeToggle from "react-dark-mode-toggle";

const Header = () => {
  return (
    <div className="flex justify-between items-center h-16 w-full border-b-2 border-gray-800 px-4 md:px-0">
      <h1 className="text-lg sm:text-2xl cursor-pointer">
        <a href="/">WebRTC Video Chat</a>
      </h1>
      <div className="cursor-pointer flex justify-center items-center gap-2 sm:gap-4 text-sm sm:text-md md:text-lg">
        <a href="/about">How it Works?</a>
        <a href="https://github.com/huzaifa-99">
          <GoMarkGithub className={"text-xl sm:text-2xl"} />
        </a>
      </div>
      {/* <DarkModeToggle speed={2} className="w-14" size={55} /> */}
    </div>
  );
};

export default Header;
